(function () {
  function activateShade(section, shadeId) {
    var triggers = section.querySelectorAll('.lp-shade-range__shade');
    var images = section.querySelectorAll('.lp-shade-range__image');
    var badgeSwatch = section.querySelector('.lp-shade-range__badge-swatch-inner');
    var badgeLabel = section.querySelector('.lp-shade-range__badge-label');
    var activeTrigger = section.querySelector('.lp-shade-range__shade[data-shade-trigger="' + shadeId + '"]');

    triggers.forEach(function (trigger) {
      var isMatch = trigger.getAttribute('data-shade-trigger') === shadeId;
      trigger.classList.toggle('is-active', isMatch);
      trigger.setAttribute('aria-selected', isMatch ? 'true' : 'false');
    });

    images.forEach(function (image) {
      var isMatch = image.getAttribute('data-shade-image') === shadeId;
      image.classList.toggle('is-active', isMatch);
    });

    if (activeTrigger && badgeSwatch && badgeLabel) {
      var swatchColor = activeTrigger.getAttribute('data-shade-color');
      var shadeTitle = activeTrigger.getAttribute('data-shade-title');

      if (swatchColor) {
        badgeSwatch.style.backgroundColor = swatchColor;
      }

      if (shadeTitle) {
        badgeLabel.textContent = shadeTitle;
      }
    }
  }

  function initShadeRange(section) {
    var triggers = section.querySelectorAll('.lp-shade-range__shade');

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var shadeId = trigger.getAttribute('data-shade-trigger');
        if (shadeId) {
          activateShade(section, shadeId);
        }
      });
    });

    var activeTrigger = section.querySelector('.lp-shade-range__shade.is-active');
    if (activeTrigger) {
      var activeShadeId = activeTrigger.getAttribute('data-shade-trigger');
      if (activeShadeId) {
        activateShade(section, activeShadeId);
      }
    }
  }

  function initAll() {
    document.querySelectorAll('.lp-shade-range').forEach(initShadeRange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.lp-shade-range');
    if (section) {
      initShadeRange(section);
    }
  });
})();
